import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UpdateCustomerGroupHoldProductionMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerGroupHoldProductionInput;
}>;


export type UpdateCustomerGroupHoldProductionMutation = { __typename?: 'Mutation', updateCustomerGroupHoldProduction: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, holdProduction: boolean, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const UpdateCustomerGroupHoldProductionDocument = new TypedDocumentString(`
    mutation UpdateCustomerGroupHoldProduction($input: UpdateCustomerGroupHoldProductionInput!) {
  updateCustomerGroupHoldProduction(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  holdProduction
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpdateCustomerGroupHoldProduction: build.mutation<UpdateCustomerGroupHoldProductionMutation, UpdateCustomerGroupHoldProductionMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerGroupHoldProductionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpdateCustomerGroupHoldProductionMutation } = injectedRtkApi;
